import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const awsRumIds = new Map<string, { appMonitorId: string; identityPoolId: string }>([
  [
    'local.letsgetchecked-dev1.com',
    {
      appMonitorId: 'bc1798ea-b2c9-4aa7-b5e9-563003ed5d98',
      identityPoolId: 'us-east-1:ea40e1ca-a212-40e4-92b6-e0bb6bbea05f',
    },
  ],
  [
    'www.letsgetchecked-dev1.com',
    {
      appMonitorId: 'bc1798ea-b2c9-4aa7-b5e9-563003ed5d98',
      identityPoolId: 'us-east-1:ea40e1ca-a212-40e4-92b6-e0bb6bbea05f',
    },
  ],
  [
    'www.letsgetchecked-stg2.com',
    {
      appMonitorId: 'e1b78e8f-2777-4e43-8d9a-28b17ff948e3',
      identityPoolId: 'us-east-1:baf5a550-fdf7-4780-a6c8-22ae7fcb452b',
    },
  ],
  [
    'www.letsgetchecked.com',
    {
      appMonitorId: 'e15433f5-c2a7-454d-a02a-b567b285c001',
      identityPoolId: 'us-east-1:54e7c59f-6541-40c9-95ab-3152f8cc3204',
    },
  ],
]);

export const initAwsRum = (): AwsRum | undefined => {
  try {
    // eslint-disable-next-line no-restricted-globals
    const envConfig = awsRumIds.get(location.host);

    const awsRumConfig: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: envConfig?.identityPoolId ?? '',
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      cookieAttributes: {
        unique: true,
      },
      sessionAttributes: {
        applicationName: 'product-recommender',
      },
      enableXRay: false,
    };

    const APPLICATION_ID = envConfig?.appMonitorId ?? '';
    const APPLICATION_VERSION = process.env.NODE_ENV ?? 'local';
    const APPLICATION_REGION = 'us-east-1';

    return new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, awsRumConfig);
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    // eslint-disable-next-line no-console
    console.error(error);
    return undefined;
  }
};

const awsRum = initAwsRum();
awsRum?.recordPageView({
  pageId: window.location.pathname,
});

const recordError = <T extends Error>(error: T): void => {
  awsRum?.recordError(error);
};

// eslint-disable-next-line @typescript-eslint/ban-types
const recordEvent = <T extends {}>(eventType: string, eventData: T): void => {
  awsRum?.recordEvent(eventType, eventData);
};

export { recordError, recordEvent };
